import { buildProps } from '@lit-element/utils'
import type { ExtractPropTypes } from 'vue'
import type resizeObserver from './resizeObserver.vue'

export const resizeObserverProps = buildProps({
  disabled: {
    type: Boolean,
    default: false,
  },
  width: {
    type: Number,
    default: 300,
  },
  height: {
    type: Number,
    default: 200,
  },
  throttle: {
    type: [Number, Boolean],
    default: false,
  },
} as const)
export type ResizeObserverProps = ExtractPropTypes<typeof resizeObserverProps>
export type ResizeObserverInstance = InstanceType<typeof resizeObserver>
